import { Either, left, right } from 'fp-ts/lib/Either';
import { csosIcamServiceApi, ErrorCode, IError, IICAMToken } from '..';
import { compose as lcompose } from 'lodash/fp';
import { pathOr } from 'rambda';

export async function icamService(
  code: string
): Promise<Either<IError, IICAMToken>> {
  return await csosIcamServiceApi()
    .post(`/v1/api/icam/token`, { code })
    .then(lcompose(right))
    // .then(
    //   always(
    //     left({
    //       message: 'Legacy and Icam names do not match.',
    //       code: ErrorCode.IcamApiError,
    //     })
    //   )
    // )
    .catch(
      lcompose(
        left,
        (message: string) => ({ message, code: ErrorCode.IcamApiError }),
        pathOr('icam/token error', 'response.data.message')
      )
    );
}

export function refreshToken(): Promise<Either<IError, IICAMToken>> {
  return (
    csosIcamServiceApi()
      .post(`v1/api/icam/refresh-token`)
      .then(lcompose(right))
      // .then(r => left({ code: 400, message: '' }))
      .catch(e => left(e))
  );
}

export const logout: () => Promise<Either<undefined, undefined>> = () =>
  csosIcamServiceApi()
    .post(`v1/api/icam/logout`)
    .then(r => right(void 0))
    .catch(e => left(void 0));

export const nonce: () => Promise<Either<undefined, string>> = () =>
  csosIcamServiceApi()
    .get(`/v1/api/icam/nonce`)
    .then(r => right(r.data))
    .catch(e => left(void 0));
